/////////////////////////////////////////////////////////////////////////////////////////////////////////
// 화일명 : useDatePickerLocale.ts
// 설명 : 앱 언어(language) 선택에 따라 MUI DatePicker/dayjs의 로케일(달력 요일/월/버튼 문구) 및
//        화면표시 포맷(dateFormat/monthFormat)을 맞춰주는 훅
//  - LocalizationProvider의 adapterLocale, localeText에 그대로 전달해서 사용
//  - DatePicker의 format prop에 dateFormat(일자)/monthFormat(년월)을 전달해서 사용
//  - 주의: 값 저장/전송 포맷(onChange에서 newValue.format('YYYY-MM-DD')로 만드는 값)은
//         화면표시 포맷과 무관하게 항상 'YYYY-MM-DD'/'YYYY-MM'(ISO)로 고정 유지할 것 - 백엔드 계약
/////////////////////////////////////////////////////////////////////////////////////////////////////////
import 'dayjs/locale/ko';
import 'dayjs/locale/en';
import 'dayjs/locale/ja';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/vi';
import { koKR, enUS, jaJP, zhCN, viVN } from '@mui/x-date-pickers/locales';
import { useCommonTranslation } from '../translations';

// 앱 언어코드(ko/en/jp/zh/vn) -> dayjs 로케일 문자열
const DAYJS_LOCALE_MAP: Record<string, string> = { ko: 'ko', en: 'en', jp: 'ja', zh: 'zh-cn', vn: 'vi' };
// 앱 언어코드 -> MUI DatePicker 로케일 객체(지우기/오늘/확인 등 버튼 문구)
const MUI_LOCALE_MAP: Record<string, any> = { ko: koKR, en: enUS, jp: jaJP, zh: zhCN, vn: viVN };
// 앱 언어코드 -> 화면표시 일자 포맷 (국가별 표기 관례)
const DATE_FORMAT_MAP: Record<string, string> = { ko: 'YYYY-MM-DD', en: 'MM/DD/YYYY', jp: 'YYYY/MM/DD', zh: 'YYYY-MM-DD', vn: 'DD/MM/YYYY' };
// 앱 언어코드 -> 화면표시 년월 포맷
const MONTH_FORMAT_MAP: Record<string, string> = { ko: 'YYYY-MM', en: 'MM/YYYY', jp: 'YYYY/MM', zh: 'YYYY-MM', vn: 'MM/YYYY' };

export function useDatePickerLocale() {
    const { language } = useCommonTranslation();
    const muiLocale = MUI_LOCALE_MAP[language] || koKR;
    return {
        adapterLocale: DAYJS_LOCALE_MAP[language] || 'ko',
        localeText: muiLocale.components.MuiLocalizationProvider.defaultProps.localeText,
        dateFormat: DATE_FORMAT_MAP[language] || 'YYYY-MM-DD',
        monthFormat: MONTH_FORMAT_MAP[language] || 'YYYY-MM',
    };
}
